import * as React from 'react';
import * as cn from 'classnames';
import * as styles from './styles.css';

export type TBulletColor = 'blue' | 'red';

export const DEFAULT_LINE_HEIGHT = 20;

export interface IBulletListItemProps {
  children: React.ReactNode;
  lineHeight?: number;
  bulletColor?: TBulletColor;
  inline?: boolean;
}

export function BulletListItem({
  children,
  lineHeight = DEFAULT_LINE_HEIGHT,
  bulletColor = 'blue',
  inline,
}: IBulletListItemProps) {
  return (
    <div className={cn(styles['container'], inline && styles['inline'])}>
      <span
        className={cn(styles['bullet'], styles[`bullet-color-${bulletColor}`])}
        style={{
          top: `${lineHeight / 2}px`,
        }}
      />
      {children}
    </div>
  );
}
